import { Button, Card, CircularProgress, Grid, InputLabel } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

import { getGlobalData, updCareerEmail } from '../../../redux/actions/GlobalActions';

const Karir = () => {
  const history = useHistory();
  const [submit, setSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({});
  const handleChange = ({ target: { value, name } }) => {
    setParams((pref) => ({
      ...pref,
      [name]: value,
    }));
  };
  const handleFormSubmit = () => {
    setSubmit(true);
    updCareerEmail(params)
      .then(() => {
        showAlert("Data berhasil disimpan", true);
        setSubmit(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal menyimpan data, coba beberapa saat lagi",
          false
        );
        setSubmit(false);
      });
  };
  const showAlert = (text, success) => {
    Swal.fire({
      title: success ? "Berhasil" : "Oopss!",
      text: text,
      imageUrl: `/assets/images/icons/${
        success ? "ic_success" : "ic_error"
      }.svg`,
      imageWidth: 92,
      imageHeight: 92,
      confirmButtonText: "Ok",
      confirmButtonColor: "#0083E2",
    });
  };
  const getData = () => {
    setLoading(true);
    getGlobalData()
      .then((res) => {
        let data = res.data?.data;
        if (Object.keys(data).length > 0) {
          setParams((pref) => ({
            ...pref,
            email_apply: data?.email_apply,
          }));
        } else {
          showAlert("Gagal mengambil data, coba beberapa saat lagi", false);
        }
        setLoading(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal mengambil data, coba beberapa saat lagi",
          false
        );
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="m-sm-30">
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={11} md={12}>
          <h3 className="fw-bold m-0">Karir - Data</h3>
        </Grid>
        <Grid item xs={11} md={12}>
          <Card elevation={0} className="py-5 px-6 border-radius-0">
            {loading ? (
              <div className="text-center">
                <CircularProgress color="primary" size={35} />
              </div>
            ) : (
              <ValidatorForm onSubmit={handleFormSubmit} className="w-full">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="email_apply" className="mb-4">
                      Email Apply <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="email_apply"
                      placeholder="Email"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="email_apply"
                      value={params.email_apply || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Email terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid
                      container
                      spacing={2}
                      justifyContent="flex-end"
                      className="flex-column-reverse flex-md-row"
                    >
                      <Grid item xs={12} md={2}>
                        <Button
                          color="primary"
                          className="text-primary w-full radius-6 text-capitalize py-2"
                          disableElevation
                          disabled={submit}
                          onClick={() => history.goBack()}
                        >
                          Batal
                        </Button>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          className="text-white w-full radius-6 text-capitalize py-2"
                          disableElevation
                          disabled={submit}
                        >
                          {submit ? (
                            <CircularProgress color="primary" size={25} />
                          ) : (
                            "Simpan"
                          )}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </ValidatorForm>
            )}
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Karir;
